export default __webpack_public_path__ + "static/media/betsy.4330f02f.png";